import React, { useContext } from 'react';
import ColorsMain from '../../colors/ColorsMain';


import { UtilContext } from "../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../language/language";


const ModalAlert = ({
  onClick,
  onClickBack,
  title = `Estás seguro que deseas salir?`,
  description = `description`,
  labelButtonBlack = `Cancelar`,
  labelButtonWhite = `Si, salir`,
  className,
  icon: Icon
}) => {
  const { language } = useContext(UtilContext);


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-[#26262D] p-8 rounded-[12px] w-[490px] shadow-2xl">
        {Icon && <Icon className={'w-8 h-8 mb-4'} />}
        <p className={`font-semibold mb-4 text-3xl text-left ${className}`}>{title}</p>
        <p className={`text-[15px] text-[#B7B7B9] text-left ${className} mb-6`}>
          {description}
        </p>
        <div className="flex justify-end gap-3">
          {onClickBack && (
            <button
              onClick={onClickBack}
              className="px-4 py-2 text-white rounded-lg"
              style={{ backgroundColor: ColorsMain.borderGray }}
            >
              {GLOBAL_LANGUAGE[language].modal_alert_back.label_button_back}
            </button>
          )}
          <button
            onClick={onClick}
            className="px-4 py-2 rounded-lg"
            style={{
              backgroundColor: ColorsMain.bgButtonWhite,
              color: ColorsMain.textBlackButton,
            }}
          >
            {labelButtonWhite}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalAlert;
